


















import Vue from 'vue';
import { IProductCategory } from '../../common/interfaces/products.interface';

export default Vue.extend({
  name: `ProductsOverviewCategoriesItem`,
  computed: {
    isActive(): boolean {
      return window.location.href.includes(this.category.link);
    },
  },
  props: {
    category: {
      required: true,
      type: Object as () => IProductCategory,
    },
  },
});
